
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'MarauderPhotoAlbums',
    components: { Article }
});
